import { fadeOut, containEvent, pjaxFetch } from "../droom/utilities"


// Here we contain and update the preview of upload consequences,
// updating the column mapping and refreshing the table view as changes are made.
// 

class ProcessionUploadTable {
  constructor(el, opts={}) {
    this.holder = el;
    this.listenToElements();
  }

  listenToElements() {
    this.scroller = this.holder.querySelector(".table_scroller");
    this.mapping_selectors = this.holder.querySelectorAll("select");
    this.mapping_selectors.forEach((sel) => {
      (sel).addEventListener('input', this.applyMapping.bind(this));
    });
    this.mapping_form = this.holder.querySelector("form.mapping");
    this.mapping_field = this.mapping_form.querySelector('input[data-role="column_map"]');
    if (this.mapping_field) 
      this.mapping_field.addEventListener('change', this.updatePreview.bind(this));
  }

  applyMapping(_e) {
    const columnMap = {}
    this.mapping_selectors.forEach((sel) => {
      const param = sel.dataset.param;
      const attribute = sel.value;
      if (param !== attribute) {
        columnMap[param] = attribute;
      }
    });
    this.mapping_field.value = JSON.stringify(columnMap);
    this.mapping_field.dispatchEvent(new Event('change'));
  }

  updatePreview(_e) {
    const url = new URL(this.mapping_form.action);
    const formData = new FormData(this.mapping_form);
    pjaxFetch(url, {
      method: 'POST', 
      body: formData,
    })
    .then(this.receiveUpdate.bind(this));
  }

  receiveUpdate(text) {
    const l = this.scroller.scrollLeft;
    const t = this.scroller.scrollTop;
    const wrapper = document.createElement('div')
    wrapper.innerHTML = text;
    const preview = wrapper.firstElementChild;
    this.holder.innerHTML = preview.innerHTML;
    this.listenToElements();
    this.scroller.scrollTop = t;
    this.scroller.scrollLeft = l;
  }

  notifyOfError(error) {
    console.log("🐈 notifyOfError", error);
  }
}

function processionUploadTable(el) {
  return new ProcessionUploadTable(el);
}

export {
  processionUploadTable
};